import { SET_GLOBAL_DATA } from "utils/action-types";

export const setupGlobalData = (cartSettings, commitmentBasedDiscounts, isOneTimeCollection) => async (dispatch, getState) => {
	const { isClient } = getState().global;

	if (isClient) return;

	dispatch({ type: SET_GLOBAL_DATA, payload: {
		cartBonus: cartSettings.bonus,
		cartBoxes: cartSettings.boxes,
		commitmentBasedDiscounts,
		isOneTimeCollection
	} });
};